module.exports = __webpack_public_path__ + "media/images/mosaic_cut-14bf3498d941f080c79a5206ec7b2cb0.svg";